import { BULLET } from '../../items';
import { Maybe } from '~/data';

type itemType = {
  __typename?: 'Text';
  id: string;
  type?: Maybe<string>;
  appear?: Maybe<number>;
  disappear?: Maybe<number>;
  position?: Maybe<number>;
  variant?: Maybe<string>;
  title?: Maybe<string>;
  body?: Maybe<string>;
  subtitle?: Maybe<string>;
  icon?: Maybe<string>;
};

/**
 * Breaks down one API List item into an array of LIST items
 * @returns An array of LIST items
 */
export const ListHelper = (
  items: Maybe<Array<itemType>> | undefined,
  bulletType?: string
) => {
  return (items || []).map((item, index) => {
    const bullet = bulletType ? bulletType : item.subtitle;

    if (bulletType == 'default') {
      return {
        type: BULLET,
        id: `${item.id}_title`,
        values: {
          start: item.appear || 0,
          value: item.title
        },
        items: []
      };
    }

    if (bulletType === 'bullet') {
      return {
        type: BULLET,
        id: `${item.id}_title`,
        values: {
          start: item.appear || 0,
          bullet: index + 1,
          value: item.title
        },
        items: []
      };
    }

    return {
      type: BULLET,
      id: `${item.id}_title`,
      values: {
        start: item.appear || 0,
        bullet: bullet,
        value: item.title
      },
      items: []
    };
  });
};
